/** @format */

/**
 * External dependencies
 */
import { get } from 'lodash';
import { event as d3Event } from 'd3-selection';
import moment from 'moment';
export var drawBars = function drawBars(node, data, params, scales, formats, tooltip) {
  var height = scales.yScale.range()[0];
  var barGroup = node.append('g').attr('class', 'bars').selectAll('g').data(data).enter().append('g').attr('transform', function (d) {
    return "translate(".concat(scales.xScale(d.date), ", 0)");
  }).attr('class', 'bargroup').attr('role', 'region').attr('aria-label', function (d) {
    return params.mode === 'item-comparison' ? formats.screenReaderFormat(d.date instanceof Date ? d.date : moment(d.date).toDate()) : null;
  });
  barGroup.append('rect').attr('class', 'barfocus').attr('x', 0).attr('y', 0).attr('width', scales.xGroupScale.range()[1]).attr('height', height).attr('opacity', '0').on('mouseover', function (d, i, nodes) {
    tooltip.show(data.find(function (e) {
      return e.date === d.date;
    }), d3Event.target, nodes[i].parentNode);
  }).on('mouseout', function () {
    return tooltip.hide();
  });
  var basePosition = scales.yScale(0);
  barGroup.selectAll('.bar').data(function (d) {
    return params.visibleKeys.map(function (row) {
      return {
        key: row.key,
        focus: row.focus,
        value: get(d, [row.key, 'value'], 0),
        label: row.label,
        visible: row.visible,
        date: d.date
      };
    });
  }).enter().append('rect').attr('class', 'bar').attr('x', function (d) {
    return scales.xGroupScale(d.key);
  }).attr('y', function (d) {
    return Math.min(basePosition, scales.yScale(d.value));
  }).attr('width', scales.xGroupScale.bandwidth()).attr('height', function (d) {
    return Math.abs(basePosition - scales.yScale(d.value));
  }).attr('fill', function (d) {
    return params.getColor(d.key);
  }).attr('pointer-events', 'none').attr('tabindex', '0').attr('aria-label', function (d) {
    var label = d.label || d.key;

    if (params.mode === 'time-comparison') {
      var dayData = data.find(function (e) {
        return e.date === d.date;
      });
      label = formats.screenReaderFormat(moment(dayData[d.key].labelDate).toDate());
    }

    return "".concat(label, " ").concat(tooltip.valueFormat(d.value));
  }).style('opacity', function (d) {
    var opacity = d.focus ? 1 : 0.1;
    return d.visible ? opacity : 0;
  }).on('focus', function (d, i, nodes) {
    var targetNode = d.value > 0 ? d3Event.target : d3Event.target.parentNode;
    tooltip.show(data.find(function (e) {
      return e.date === d.date;
    }), targetNode, nodes[i].parentNode);
  }).on('blur', function () {
    return tooltip.hide();
  });
};
//# sourceMappingURL=bar-chart.js.map